import { Diamond, Hot } from '~/vendor/cxy/icons/glyphs/components/cxy-components/svg';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';

import { Tooltip } from '../Tooltip';

import styles from './styles/BetType.module.scss';

const VARIANTS = {
  DIAMOND_IN_THE_ROUGH: 'DIAMOND_IN_THE_ROUGH',
  HOTTEST_PROP: 'HOTTEST_PROP',
  HOTTEST: 'HOTTEST',
} as const;

type BetVariant = keyof typeof VARIANTS;

export const betTypeVariants = cva(styles.betType, {
  variants: {
    variant: {
      [VARIANTS.DIAMOND_IN_THE_ROUGH]: styles.diamond,
      [VARIANTS.HOTTEST_PROP]: styles.hot,
      [VARIANTS.HOTTEST]: styles.hot,
    },
    size: {
      small: styles.small,
      medium: styles.medium,
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

const VARIANT_TRIGGERS: Record<BetVariant, React.ReactNode> = {
  DIAMOND_IN_THE_ROUGH: Diamond,
  HOTTEST_PROP: Hot,
  HOTTEST: Hot,
};

export interface BetTypeProps extends Omit<React.ComponentPropsWithoutRef<typeof RadixTooltip.Content>, 'content'> {
  className?: string;
  label: string;
  onOpenChange?: (open: boolean) => void;
  size?: 'small' | 'medium';
  variant: BetVariant;
}

export const BetType = ({
  className, // Keep left as default to not affect existing usage
  label,
  onOpenChange,
  side = 'left',
  size = 'medium',
  variant,
  ...props
}: BetTypeProps) => {
  return (
    <Tooltip onOpenChange={onOpenChange}>
      <Tooltip.Trigger aria-label={label} asChild className={clsx(betTypeVariants({ variant, size }), className)}>
        {VARIANT_TRIGGERS[variant]}
      </Tooltip.Trigger>
      <Tooltip.Content
        align="center"
        className={styles.content}
        data-cxy-name="bet-type"
        side={side}
        sideOffset={5}
        {...props}
      >
        {label}
        <RadixTooltip.Arrow className={styles.arrow} />
      </Tooltip.Content>
    </Tooltip>
  );
};
